export default __webpack_public_path__ + "7bc671c24cc91ac2e8634d89208b22c2.jpg";